import React from "react";
import DeploymentPackCard from "./DeploymentPackCard";
import ExportTargets from "./ExportTargets";

const ExportSection = ({
  modelType,
  versionId,
  modelName,
  version,
  apiBaseUrl,
  exportingOnnx,
  exportingOpenVino,
  onExportOnnx,
  onExportOpenVino,
  onDownloadNative,
  pack,
}) => (
  <section className="export-section">
    <div className="export-section__grid">
      <div className="export-section__card">
        <div className="export-section__card-header">
          <strong>API Usage</strong>
        </div>
        <div className="export-section__card-body">
          <p className="export-section__label">Endpoint</p>
          <code className="export-section__code">
            {apiBaseUrl}/inference/{modelType || "model"}/{versionId}
          </code>
          <p className="export-section__label">Example request</p>
          <pre className="export-section__pre">
{`POST /inference/${modelType || "model"}/${versionId}
Authorization: Bearer <token>
Content-Type: multipart/form-data

file=@image.jpg`}
          </pre>
        </div>
      </div>
      <div className="export-section__card">
        <div className="export-section__card-header">
          <strong>Model Downloads</strong>
        </div>
        <div className="export-section__card-body">
          <p className="export-section__label">Export formats</p>
          <div className="btn-group mb-2">
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              disabled={exportingOnnx}
              onClick={onExportOnnx}
            >
              {exportingOnnx ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-1" role="status" />
                  Exporting…
                </>
              ) : (
                "ONNX"
              )}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              disabled={exportingOpenVino}
              onClick={onExportOpenVino}
            >
              {exportingOpenVino ? (
                <>
                  <span className="spinner-border spinner-border-sm mr-1" role="status" />
                  Exporting…
                </>
              ) : (
                "OpenVINO"
              )}
            </button>
            <button type="button" className="btn btn-sm btn-primary" onClick={onDownloadNative}>
              Native (.pt / full run)
            </button>
          </div>
          <p className="export-section__hint">Includes full run folder (.pt, metrics, etc.).</p>
        </div>
      </div>
    </div>
    {/* Its own full-width row rather than a third grid cell: a 2-column grid with three
        cards leaves a hole at every width, and this card's facts list (id, digest,
        classes) needs the horizontal room the grid cells do not have. */}
    {pack && (
      <div className="export-section__wide">
        <DeploymentPackCard modelType={modelType} {...pack} />
      </div>
    )}
    {/* BESIDE the pack card, never instead of it. The pack is one provider-agnostic
        artifact; this is the list of places it may be sent, and it renders whether or
        not a pack exists — "there is nowhere to send it yet" is a thing somebody needs
        to find out BEFORE spending a build on one. */}
    <div className="export-section__wide">
      <ExportTargets
        modelType={modelType}
        packReady={Boolean(pack?.pack?.status === "ready")}
      />
    </div>
  </section>
);

export default ExportSection;
